module.exports = __webpack_public_path__ + "img/sample.158c691c.png";